import { render, staticRenderFns } from "./OneTimeMenu.vue?vue&type=template&id=39874f09&scoped=true"
import script from "./OneTimeMenu.vue?vue&type=script&lang=js"
export * from "./OneTimeMenu.vue?vue&type=script&lang=js"
import style0 from "./OneTimeMenu.vue?vue&type=style&index=0&id=39874f09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39874f09",
  null
  
)

export default component.exports